import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { class: "altru-button__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($props.href)
    ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        target: "_blank",
        class: "link",
        href: $props.href
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 8, _hoisted_1))
    : (_openBlock(), _createElementBlock("button", {
        key: 1,
        class: _normalizeClass(['btn', $props.variant]),
        disabled: $props.disabled,
        onClick: _cache[0] || (_cache[0] = (ev) => _ctx.$emit('click', ev))
      }, [
        _createElementVNode("span", _hoisted_3, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ], 10, _hoisted_2))
}